import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/search.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm search [search terms ...]

aliases: find, s, se
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/search.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Search the registry for packages matching the search terms. `}<inlineCode parentName="p">{`npm search`}</inlineCode>{`
performs a linear, incremental, lexically-ordered search through package
metadata for all files in the registry. If your terminal has color
support, it will further highlight the matches in the results.  This can
be disabled with the config item `}<inlineCode parentName="p">{`color`}</inlineCode></p>
    <p>{`Additionally, using the `}<inlineCode parentName="p">{`--searchopts`}</inlineCode>{` and `}<inlineCode parentName="p">{`--searchexclude`}</inlineCode>{` options
paired with more search terms will include and exclude further patterns.
The main difference between `}<inlineCode parentName="p">{`--searchopts`}</inlineCode>{` and the standard search terms
is that the former does not highlight results in the output and you can
use them more fine-grained filtering. Additionally, you can add both of
these to your config to change default search filtering behavior.`}</p>
    <p>{`Search also allows targeting of maintainers in search results, by prefixing
their npm username with `}<inlineCode parentName="p">{`=`}</inlineCode>{`.`}</p>
    <p>{`If a term starts with `}<inlineCode parentName="p">{`/`}</inlineCode>{`, then it's interpreted as a regular expression
and supports standard JavaScript RegExp syntax. In this case search will
ignore a trailing `}<inlineCode parentName="p">{`/`}</inlineCode>{` .  (Note you must escape or quote many regular
expression characters in most shells.)`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`long`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Show extended information in `}<inlineCode parentName="p">{`ls`}</inlineCode>{`, `}<inlineCode parentName="p">{`search`}</inlineCode>{`, and `}<inlineCode parentName="p">{`help-search`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`color`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true unless the NO_COLOR environ is set to something other than '0'`}</li>
      <li parentName="ul">{`Type: "always" or Boolean`}</li>
    </ul>
    <p>{`If false, never shows colors. If `}<inlineCode parentName="p">{`"always"`}</inlineCode>{` then always shows colors. If
true, then only prints color codes for tty file descriptors.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`parseable`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Output parseable results from commands that write to standard output. For
`}<inlineCode parentName="p">{`npm search`}</inlineCode>{`, this will be tab-separated table format.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`description`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Show the description in `}<inlineCode parentName="p">{`npm search`}</inlineCode></p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`searchopts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Space-separated options that are always passed to search.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`searchexclude`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Space-separated options that limit the results from search.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`prefer-online`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, staleness checks for cached data will be forced, making the CLI
look for updates immediately even for fresh package data.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`prefer-offline`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, staleness checks for cached data will be bypassed, but missing data
will be requested from the server. To force full offline mode, use
`}<inlineCode parentName="p">{`--offline`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`offline`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Force offline mode: no network requests will be done during install. To
allow the CLI to fill in missing cache data, see `}<inlineCode parentName="p">{`--prefer-offline`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-view"
        }}>{`npm view`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-cache"
        }}>{`npm cache`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/npm-registry-fetch"
        }}>{`https://npm.im/npm-registry-fetch`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      